import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@mantine/core';
import { File, Shirt } from 'tabler-icons-react';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppCard from '../../common/AppCard';
import * as classes from '../../../styles/nestedStyles.module.css';
import AppFlexbox from '../../common/AppFlexbox';
import { EXTERNAL_CONNECTION_CONFIGS } from '../external/config/externalConnectionConfigs';

const ImportProductsLocationModal = ({ onSelect, isOpen, onClose }) => (
  <ResponsiveModal isOpen={isOpen} onClose={onClose} title="Import Products">
    <AppStack>
      <AppText
        style={{
          fontSize: 14,
          color: '#666',
          fontStyle: 'italic',
          textAlign: 'center'
        }}
      >
        Select the location where you want to import products from.
      </AppText>

      <AppStack style={{ gap: 16 }}>
        {EXTERNAL_CONNECTION_CONFIGS.filter((c) => !!c.products)
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((config) => (
            <AppCard
              key={config.routeValue}
              className={classes['hover-action-card']}
              onClick={() => {
                onSelect(config.routeValue);
              }}
              radius={8}
              shadow="none"
              style={{ padding: 0, textDecoration: 'none', color: '#000' }}
              withBorder
            >
              <AppFlexbox style={{ gap: 0, alignItems: 'center' }}>
                <AppStack style={{ padding: 16 }}>
                  <Shirt size={40} />
                </AppStack>

                <Divider orientation="vertical" />

                <AppStack style={{ padding: 16 }}>
                  <AppText style={{ fontWeight: 500, fontSize: 16 }}>
                    {config.title}
                  </AppText>
                </AppStack>
              </AppFlexbox>
            </AppCard>
          ))}

        <AppCard
          className={classes['hover-action-card']}
          onClick={() => {
            onSelect();
          }}
          radius={8}
          shadow="none"
          style={{ padding: 0 }}
          withBorder
        >
          <AppFlexbox style={{ gap: 0, alignItems: 'center' }}>
            <AppStack style={{ padding: 16 }}>
              <File size={40} />
            </AppStack>

            <Divider orientation="vertical" />

            <AppStack style={{ padding: 16 }}>
              <AppText style={{ fontWeight: 500, fontSize: 16 }}>
                CSV File
              </AppText>
            </AppStack>
          </AppFlexbox>
        </AppCard>
      </AppStack>
    </AppStack>
  </ResponsiveModal>
);

ImportProductsLocationModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func
};

export default ImportProductsLocationModal;
